import { Link, NavLink } from "react-router-dom";

/** Top navigation links — the horizontal button bar under the masthead. */
const TOP_NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/projects", label: "Projects" },
  { to: "/cv", label: "CV" },
  { to: "/search", label: "Search" },
  { to: "/blog", label: "Blog" },
  { to: "/news", label: "News" },
  { to: "/contact", label: "Contact" },
];

/**
 * Masthead: a navy title banner with the site name, then a beveled horizontal
 * nav bar — the way a mid-90s homepage stacked its banner on top and a button
 * bar beneath it. (Primary site sections also live in the left sidebar.)
 */
export function Header() {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="brand" aria-label="Casey Scott McKay — home">
          <svg className="brand__mark" viewBox="0 0 64 64" aria-hidden="true">
            <rect width="64" height="64" fill="#ffffff" />
            <rect x="3" y="3" width="58" height="58" fill="none" stroke="#000080" strokeWidth="3" />
            <text x="32" y="42" textAnchor="middle" fontFamily="Courier New, monospace"
                  fontSize="30" fontWeight="700" fill="#000080">C</text>
          </svg>
          <span className="brand__name">Casey Scott McKay</span>
        </Link>
      </div>

      <nav className="nav" aria-label="Top">
        {TOP_NAV.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            {link.label}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}
